module.exports = __webpack_public_path__ + "img/big-explosion.434e55c8.png";